module.exports = __webpack_public_path__ + "img/veritas_pin_covid19.1f69518d.jpg";